import { useLayoutEffect } from "react";

const isomorphic = {
  get window() {
    if (typeof window !== "undefined") return window;
    throw new Error("`window` is undefined in this environment.");
  },
  get windowSafe() {
    if (typeof window !== "undefined") return window;
    return null;
  },
};

const INITIAL_TITLE = isomorphic.windowSafe?.document.title || "";

// DEV: effects are called from the child up - freezing the title ensures that the child component is not overwritten
let freezeTitle = false;

/**
 * Provide a title string, it'll be set in the browser with a render-blocking effect.
 *
 * @param {string} title The page title
 *
 * @returns {undefined}
 *
 * @example
 *
 * usePage('My Title')
 * // => document.title === 'My Title'
 *
 */

const usePageTitle = (title: string): void => {
  useLayoutEffect(() => {
    if (!freezeTitle) {
      isomorphic.window.document.title = title;
      freezeTitle = true;
      return () => {
        isomorphic.window.document.title = INITIAL_TITLE;
        freezeTitle = false;
      };
    }
  }, [title]);
};

export default usePageTitle;
